<template>
    <div class="main-bg">
        <div class="flex flex-col flex-auto w-full h-full" style="max-height: 100vh;height: 100vh !important;">
            <div class="flex flex-col flex-auto">
                <div class="login-outlet flex flex-col cr-backimg">
                    <div class="flex items-center justify-between w-full padding-x padding-bottom">
                        <div class="flex md:justify-start py-5">
                            <div style="" class="p-1">
                                <img src="/static/images/Digicollect_Logo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 35px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                        </div>
                        <!-- Digihelp -->
                        <div v-if="product_name=='DigiHelp'" class="flex items-end justify-end text-default-blue crm-right-logo py-6" style="font-size: 23px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/help_whitelogo.svg" alt="DigiHelp" class="digiadmin-logo" style="width: 35px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            DigiHelp
                        </div>
                        <!-- HRMS -->
                        <div v-else-if="product_name=='digiHRMS'" class="flex items-end justify-end text-default-blue crm-right-logo md:p-16 pxy-28loginheader" style="font-size: 26px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/hrms_newlogo.svg" alt="DigiHRMS" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            DigiHRMS
                        </div>
                        <!-- Admin -->
                        <div v-else-if="product_name=='digiAdmin'" class="flex items-end justify-end text-default-blue crm-right-logo md:p-16 pxy-28loginheader" style="font-size: 26px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/admin-logo.svg" alt="DigiAdmin" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px;border-radius: 4px;"> 
                            </div>
                            DigiAdmin
                        </div>
                        <!-- digiExpense -->
                        <div v-else-if="product_name=='digiExpense'" class="flex items-end justify-end text-default-blue crm-right-logo md:p-16 pxy-28loginheader" style="font-size: 26px; color: #fff !important;font-weight: 600;font-family: 'Poppins', sans-serif !important;padding-right: 30px;">
                            <div style="" class="px-1 mr-1">
                                <img src="https://cdn.digicollect.com/cdn/dc_admin/img/expense-logo.svg" alt="DigiExpense" class="digiadmin-logo" style="width: 40px; height: auto;border: 0.5px solid #fff;padding: 6px 9px;border-radius: 4px;"> 
                            </div>
                            DigiExpense
                        </div>
                    </div>
                    <div class="flex flex-col sm:flex-row items-center md:items-start sm:justify-center md:justify-start flex-auto min-w-0 pb-5">
                        <div class="relative hidden md:flex flex-col items-start justify-center w-1/2 md:p-16login lg:pxy-28login overflow-hidden bg-gray-800 dark:border-r"> 
                            <div class="width-leftbox">
                                <!-- digihelp -->
                                <div v-if="product_name=='DigiHelp' && activediv !== 'forgot password' && activediv !== 'verify otp' && activediv != 'set new password'" >
                                    <span class="font-size-header fw-800 disable-select" style="color: #fff;">Streamlining HelpDesk!</span>
                                </div> 
                                <div v-else>
                                    <span class="font-size-header fw-800 disable-select" style="color: #fff;">Reset Password!</span>
                                </div> 
                                
                                <!-- digiHRMS -->
                                <div v-if="product_name=='digiHRMS'">
                                    <span class="font-size-header fw-800 disable-select" style="color: #fff;">Streamlining Resources!</span>
                                </div>
                                <!-- digiAdmin -->
                                <div v-else-if="product_name=='digiAdmin'">
                                    <span class="font-size-header fw-800 disable-select" style="color: #fff;">Central Hub for DigiApps!</span>
                                </div>
                                <!-- digiExpense -->
                                <div v-else-if="product_name=='digiExpense'">
                                    <span class="font-size-header fw-800 disable-select" style="color: #fff;">Track Company’s Expenses!</span>
                                </div>
                                <hr class="mt-5 streamLine">
                                <div v-if="activediv == 'forgot password' || activediv == 'set new password'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="/static/images/forgot-password.svg" alt="" width="85%">
                                    </div>
                                    <!-- <div class="mt-8">
                                        <span class="fs-18 disable-select" style="color: #fff;">
                                            No worries! Set your new password following these simple steps.
                                        </span>
                                    </div> -->
                                </div>
                                <div v-else-if="activediv == 'verify otp'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="/static/images/forgot-password.svg" alt="" width="85%">
                                    </div>
                                    <!-- <div class="mt-8">
                                        <span class="fs-18 disable-select" style="color: #fff;">
                                            No worries! Set your new password following these simple steps.
                                        </span>
                                    </div> -->
                                </div>
                                <!-- digihelp -->
                                <div v-if="product_name=='DigiHelp' && activediv != 'forgot password' && activediv != 'verify otp' && activediv != 'set new password'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="https://cdn.digicollect.com/cdn/dc_admin/img/newlogin.svg" alt="" width="100%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-16 full-width-text disable-select" style="color: #fff;">An integrated ticketing system that manages workflow and 
                                            communication with customers and users. Helps in tracking
                                            tickets and their progress in real time.
                                        </span>
                                    </div>

                                </div>
                                <!-- digiHRMS -->
                                <div v-else-if="product_name=='digiHRMS'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="https://cdn.digicollect.com/cdn/dc_admin/img/hrms-illustrator.svg" alt="" width="100%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-16 disable-select" style="color: #fff;">
                                            DigiHRMS helps in overseeing the people within an organization. 
                                            It  keeps  the  data, information,  and  updates  in  a  centralized 
                                            location systematically and manage each bit of HR operations 
                                            include Employee Info, Payroll, Leave and Attendance.
                                        </span>
                                    </div>
                                </div> 
                                <!-- digiAdmin -->
                                <div v-else-if="product_name=='digiAdmin'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="https://cdn.digicollect.com/cdn/dc_admin/img/admi-illustrator.svg" alt="" width="100%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-16 disable-select" style="color: #fff;">
                                            DigiAdmin is a centre coordinator app for all products. It manages
                                            User access and product access of all the employees working under 
                                            specific company Of an organisation.
                                        </span>
                                    </div>
                                </div> 
                                <!-- digiExpense -->
                                <div v-else-if="product_name=='digiExpense'">
                                    <div class="mt-4 px-8 text-center">
                                        <img src="https://cdn.digicollect.com/cdn/dc_admin/img/expense-illustrator.svg" alt="" width="100%">
                                    </div>
                                    <div class="mt-8">
                                        <span class="fs-16 disable-select" style="color: #fff;">
                                            DigiExpense keeps track of expenses made and easy retrieval of 
                                            reports for a required date range displaying all the expenses.The 
                                            Employees uses the DigiExpense application to keep the record 
                                            of their expenses in the real time.
                                        </span>
                                    </div>
                                </div> 
                            </div>
                        </div>
                        <div class="md:flex flex-col items-end justify-center w-full sm:w-auto  md:w-1/2 py-8 px-4 lg:pxy-28login sm:p-12 md:p-16login sm:rounded-2xl md:rounded-none sm:shadow md:shadow-none sm:bg-card mb-15">
                            <div style="width: 100%;">
                                <div class="right-box">
                                    <div v-if="activediv == 'login'">
                                        <div style="text-align: center !important;">
                                            <span class="text-white text-center fs-30 fw-600">
                                                Sign 
                                            </span>
                                            <span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">In</span>
                                        </div>
                                        <!-- <div v-if="enter_email_screen">
                                        </div> -->
                                        <form action="javascript:;">
                                            <div v-if="enter_email_screen" class="mt-6">
                                                <div class="h-30-20-10rem">
                                                    <p class="text-default-heading mb-3 text-white fw-600">Email Address<span class="star ml-1">*</span></p>
                                                    <div class="w-100" v-if="oldlogin_id">
                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" v-validate="'required'" v-model="form.login_id">

                                                        </div>
                                                    </div>
                                                    <div class="w-100" v-if="login_id_true">
                                                        <div class="d-flex justify-content-end align-items-center">
                                                            <input type="text" autocomplete="off" @keyup.enter="goToNext('login')" class="digi-form-full-bordered mb-2" autofocus name="userid" placeholder="Enter Email Address" @input="checkUserIdback" v-model="form.login_id" >
                                                            <div>
                                                                <img src="/static/images/check-fill.svg" width="20px" style="margin-left: -35px;margin-bottom: 6px">
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <!-- v-if="is_email_valid_text && form.login_id != ''" -->
                                                    <span class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;" v-show="errors.has('userid')" v-if="is_email_valid_text && form.login_id != ''" >Please Enter a Valid Email Address</span>
                                                    <span v-if="is_email_phone_valid" class="text-danger fw-600 fs-14 mb-5" style="text-transform: none !important;">{{is_email_phone_valid_text}}</span>
                                                </div>
                                                    <div v-if="login_id_true" class="forgot-password-button mt-8" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize fs-14 mr-5" type="button" @click="checkUserIdEmpty">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize fs-14"  type="button" @click="goToNext('login')">Sign In</button>
                                                    </div>
                                                <div v-else class="mt-8 d-flex justify-content-end">
                                                    <button class="btn newsign-in text-capitalize font-weight-bold fs-14"  type="button" @click="goToNext('login')">Sign In</button>
                                                </div>
                                            </div>
                                            <div v-if="user_not_verified" class="mt-6">
                                                <h1 v-if="login_type == 'email'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"><span class="text-white"><img src="/static/images/author-img.svg" alt="" width="34px">{{form.login_id}}</span></h1>
                                                <div class="text-center" style="max-width: 380px">
                                                    <div class="mb-2 ml-auto mr-auto" style="max-width: 230px">
                                                        <img style="width: 100%;" src="https://cdn.digicollect.com/cdn/dc_helpdesk_new/images/images-new/menu/duck.svg" alt="Duck" />
                                                    </div>
                                                    <p class="text-white mb-2" style="font-size: 20px; font-weight: 800;">Verification Pending!!</p>
                                                    <p class="text-white mb-2" style="font-size: 14px;">Your Verification link has been expired, Resend Link to verify</p>
                                                    <div class="mt-4">
                                                        <div class="forgot-password-button" style="text-align: center;">
                                                            <button class="btn newcancel text-capitalize mb-5 mr-5" :disabled="resend_btn_disable" @click="cancelResendLink">Cancel</button>
                                                            <button class="btn newsign-in mb-5 text-capitalize" :disabled="resend_btn_disable" style="min-width: 110px; width: 160px !important;" @click="resendUserVerifyLink">Resend Link 
                                                                <hollow-dots-spinner v-if="resend_btn_disable" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                            </button>
                                                        </div>
                                                        <div v-if="resend_verification_link_success" class="text-default-blue fs-14 mt-2">{{resend_verification_link_success}}</div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div v-if="enter_pass_screen" class="mt-6">
                                                <h1 v-if="login_type == 'email'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"><img src="/static/images/author-img.svg" alt="" width="34px"> <span class="text-white">{{form.login_id}}</span></h1>
                                                <div v-if="!sign_in_using_otp">
                                                    <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                                    <div class="d-flex">
                                                        <input v-if="!showPassword" style="padding-right: 40px !important;"  oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password" @keydown.enter="loginUsingPassword('one-step')" name="password" ref="password" >
                                                        <input v-else type="text" style="padding-right: 40px !important;"  oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password " v-model="form.password" name="password" @keydown.enter="loginUsingPassword('one-step')" ref="password">
                                                        <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword =!showPassword">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                        </span>
                                                        <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                        </span>
                                                    </div>
                                                    <p v-if="password_error_text" class="text-danger mb-5">{{password_error_text}}</p>
                                                    <p class="default-link mb-5 text-white" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer highlighted-white">Forgot Password ?</span></p>
                                                    <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelPassScreen">Cancel</button>
                                                        <button :disabled="signedIn || form.password == ''" class="btn newsign-in text-capitalize" @click="loginUsingPassword('one-step')">Sign In
                                                            <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                    <div v-if="signedIn" style="text-align: center;" class="mt-6">
                                                        <p class="fs-14 mt-0 fw-600 pointer default-link highlighted-white" style="color: #fff !important;">Sign In using OTP</p>
                                                    </div>
                                                    <div v-else style="text-align: center;" class="mt-6">
                                                        <p class="fs-14 mt-0 fw-600 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToOtpLogin('send')" >Sign In using OTP</p>
                                                    </div>
                                                </div>
                                                <div v-if="sign_in_using_otp">
                                                    <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                                    <div>
                                                        <div class="d-flex align-items-start mt-2">
                                                            <div class="" @keyup.enter="loginUsingOtp('one-step')">
                                                                <v-otp-input
                                                                ref="otpInput"
                                                                :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                                separator=""
                                                                :num-inputs="6"
                                                                :should-auto-focus="true"
                                                                :is-input-num="true"
                                                                @on-complete="otpEntered"
                                                                @on-change="otpChangeDetected"
                                                                />
                                                                <div class="d-flex justify-between">
                                                                    <div style="width: 190px;" class="pt-2">
                                                                        <span class="text-white highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                    </div>
                                                                    <div style="color: #00448b" class="ml-1 mt-2 pr-8">
                                                                        <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                        <br>
                                                                        <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                    </div>
                                                                    <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-if="resend_code_success_text" class="mt-2">
                                                            <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                        </div>
                                                        <div v-if="otp_error_text" class="mt-2">
                                                            <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                        </div>
                                                    </div>
                                                    <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="signedIn">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="signedIn" @click="loginUsingOtp('one-step')">Sign In
                                                            <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                    <div class="mt-6 forgot-password-button" style="text-align: center;">
                                                        <div v-if="signedIn" style="text-align: center;">
                                                            <p class="fs-14 fw-600  mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin">Sign In Using Password</p>
                                                        </div>
                                                        <div v-else style="text-align: center;">
                                                            <p class="fs-14 mt-2 fw-600 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin">Sign In Using Password</p>
                                                        </div>
                                                        </div>
                                                </div>
                                            </div>
                                            <div v-if="two_factor_authentication" class="mt-10">
                                                <h1 v-if="login_type == 'email'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                                <h1 v-if="login_type == 'phone'" class="fs-14 mb-6 fw-600 text-white" style="margin-left:-6px !important"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                                <div v-if="two_factor_auth_pass_screen_active">
                                                    <p class="text-default-heading mb-5 text-white fw-600">Enter Password<span class="star ml-1">*</span></p>
                                                    <div class="d-flex">
                                                        <!-- <input v-if="!showPassword" autofocus @keyup.enter="otpInputActive"  style="padding-right: 40px !important;" oncopy="return false" onpaste="return false" oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password sdf sd" v-model="form.password" name="password"> -->
                                                        <input v-if="!showPassword" id="name" ref="password" @keydown.enter="otpInputActive" style="padding-right: 40px !important;"  oncut="return false" type="password"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password " v-model="form.password" name="password" autofocus>
                                                        <input v-else type="text" autofocus ref="password" name="password" @keydown.enter="otpInputActive" style="padding-right: 40px !important;"  oncut="return false"  autocomplete="off" class="digi-form-full-bordered mb-5 pr-8" placeholder="Enter Password" v-model="form.password">
                                                        <span v-if="!showPassword" style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 20px;">
                                                        </span>
                                                        <span v-else style="margin-left: -30px; margin-top: 9px;" @click="showPassword = !showPassword">
                                                            <img src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 20px;">
                                                        </span>
                                                    </div>
                                                    <p v-if="password_error_text" class="text-danger mb-5 ml-1">{{password_error_text}}</p>
                                                    <p v-if="signedIn" class="default-link mb-5 text-white highlighted-white " style="color: #fff !important;text-align: end;"><span>Forgot Password ?</span></p>
                                                    <p v-else class="default-link mb-5 text-white" @click="forgotPassword" style="color: #fff !important;text-align: end;"><span @click="forgotPassword" class="pointer highlighted-white">Forgot Password ?</span></p>
                                                    <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" :disabled="signedIn" @click="cancelTwoFactor">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="signedIn || form.password == ''" @click="otpInputActive">Sign In
                                                            <hollow-dots-spinner v-if="signedIn" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                    <p class="fs-14 mt-6 fw-600 pointer default-link highlighted-white" v-if="!signedIn" style="color: #fff !important;text-align: center;" @click="goToOtpLogin('send', 'two-factor-otp')">Sign In Using OTP</p>
                                                    <p class="fs-14 mt-6 fw-600 pointer default-link highlighted-white" v-if="signedIn" style="color: #fff !important;text-align: center;">Sign In Using OTP</p>
                                                </div>
                                                <div v-if="!two_factor_auth_pass_screen_active">
                                                    <span class="text-default-heading text-white pb-6 fs-12 fw-600">Enter 6-Digit OTP Code*</span>
                                                    <div class="d-flex align-items-start pt-2">
                                                        <div class="" @keyup.enter="loginUsingOtp('two-step')">
                                                            <v-otp-input
                                                            ref="otpInput"
                                                            :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                            separator=""
                                                            :num-inputs="6"
                                                            :should-auto-focus="true"
                                                            :is-input-num="true"
                                                            @on-complete="otpEntered"
                                                            @on-change="otpChangeDetected"
                                                            />
                                                            <div class="d-flex justify-between">
                                                                <div style="width: 190px;" class="pt-2">
                                                                    <span class="text-white highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                                </div>
                                                                <div style="color: #00448b" class="ml-1 mt-2 pr-8">
                                                                    <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="goToOtpLogin('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                    <br>
                                                                    <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                                </div>
                                                                <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                    <div v-if="resend_code_success_text" class="mt-2">
                                                        <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                    </div>
                                                    <div v-if="otp_error_text" class="mt-2">
                                                        <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                    </div>
                                                    <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                        <button class="btn newcancel text-capitalize mr-5" @click="cancelOtpScreen" :disabled="two_step_signed_in_otp">Cancel</button>
                                                        <button class="btn newsign-in text-capitalize" :disabled="two_step_signed_in_otp" @click="loginUsingOtp('two-step')">Sign In
                                                            <hollow-dots-spinner v-if="two_step_signed_in_otp" style="position: absolute;margin: 0;top: 17px;display: flex;justify-content: center;" :animation-duration="1200" :dot-size="10" :dots-num="3" :color="'#00448b'" />
                                                        </button>
                                                    </div>
                                                    <div style="text-align: center;" class="mt-6">
                                                        <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="goToPassLogin('two-factor-password')">Sign In Using Password</p>
                                                        <!-- <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" v-if="otp_signin_btn && password_button" style="color: #fff !important;">Sign In Using Password</p> -->
                                                    </div>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    <div v-if="activediv == 'forgot password'">
                                        <div>
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Forgot Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <div class="h-30-18-10rem">
                                                <p class="text-default-heading text-white mb-6 mt-10 fw-600">Email Address <span class="star ml-1">*</span></p>
                                                <input autocomplete="off" type="text" class="digi-form-full-bordered mb-2" placeholder="Enter Email Address" v-model="form.login_id" @input="checkUserIdback" @keyup.enter="goToNext('forgot-pass')">
                                                <div v-if="is_email_phone_valid && form.login_id != ''" class="text-danger fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text}}</div>
                                                <div v-if="is_email_phone_valid_text_forget_pass" class="text-danger fw-600 fs-14" style="text-transform: none !important;">{{is_email_phone_valid_text_forget_pass}}</div>
                                            </div>
                                            <div class="mt-15 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forget_pass_btn_disable">Cancel</button>
                                                <button  class="btn newsign-in text-capitalize" @click="goToNext('forgot-pass')">Verify</button>
                                            </div>
                                            <div style="text-align: center;" class="mt-6">
                                                <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="forgotPasswordCancel">Sign In</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'verify otp'">
                                        <div>
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Forgot Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <hr style="margin-left: 235px !important;width: 70px !important;margin-top: -6px !important;">
                                            <h1 v-if="is_using_email" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <h1 v-if="is_using_mobile" class="fs-14 mb-6 mt-8 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <div>
                                                <span class="text-default-heading fw-600 mr-10 fs-14 text-white pb-4">Please provide the 6-digit OTP code sent to your email address.</span>
                                                <div class="d-flex align-items-start mt-5">
                                                    <div class="" @keyup.enter="verifyOtpForgotPass">
                                                        <v-otp-input
                                                        ref="otpInput"
                                                        :input-classes="!otpInvalid ? 'otp-input' : 'otp-input-warning'"
                                                        separator=""
                                                        :num-inputs="6"
                                                        :should-auto-focus="true"
                                                        :is-input-num="true"
                                                        @on-complete="otpEntered"
                                                        @on-change="otpEntered"
                                                        />
                                                        <div class="d-flex justify-between">
                                                            <div style="width: 190px;" class="pt-2">
                                                                <span class="highlighted-white" style="color: #fff;font-size: 14px;">OTP Valid for {{Math.floor(minutes/60)}}:{{countdownseconds}} minutes</span>
                                                            </div>
                                                            <div style="color: #00448b" class="ml-1 mt-2 pr-8">
                                                                <button class="btn resend-code text-capitalize" type="button" :disabled="!countdown == 0" @click="getOtpForgetPass('resend')" :class="{'resend-active': !countdown != 0}">Resend code</button>
                                                                <br>
                                                                <span v-if="countdown > 0" class="text-white"> <span>in <span style="font-weight: 800;">{{countdown}}</span></span> seconds </span>
                                                            </div>
                                                            <div v-if="code_resending" style="color: #00448b; cursor: pointer;">Resending Code...</div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div v-if="resend_code_success_text" class="mt-2">
                                                    <span class="text-default-blue fs-14">{{resend_code_success_text}}</span>
                                                </div>
                                                <div v-if="otpInvalid" class="mt-2">
                                                    <span class="text-danger fs-14">{{otp_error_text}}</span>
                                                </div>
                                                <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                    <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel" :disabled="forgot_pass_otp_success">Cancel</button>
                                                    <button :disabled="forgot_pass_otp_success" class="btn newsign-in text-capitalize" @click="verifyOtpForgotPass">Verify</button>
                                                </div>
                                                <div style="text-align: center;" class="mt-6">
                                                    <p class="fs-14 fw-600 mt-2 pointer default-link highlighted-white" style="color: #fff !important;" @click="forgotPasswordCancel">Sign In</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'set new password'" style="height:100%;">
                                        <div>
                                            <div style="text-align: center !important;">
                                                <span class="text-white text-center fs-30 fw-600">
                                                    Set New Pass<span class="text-white text-center fs-30 fw-600" style="border-bottom: 4px solid #fff;">word</span>
                                                </span>
                                            </div>
                                            <h1 v-if="is_using_email" style="margin-left:-6px !important" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <h1 v-if="is_using_mobile" style="margin-left:-6px !important" class="fs-14 mb-4 mt-4 fw-600 font-weight-bold text-white"> <img src="/static/images/author-img.svg" alt="" width="34px"><span class="text-white">{{form.login_id}}</span></h1>
                                            <div class="row">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="text-default-heading text-white fw-600">Enter New Password<span class="star ml-1">*</span></span>
                                                    <div class="d-flex aligm-items-center mt-5 position-relative">
                                                        <input  autocomplete="off"  v-if="!showNewPassword"  type="password" @input="onPassInput" class="digi-form-full-bordered" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                        <input  autocomplete="off"  v-else type="text"  class="digi-form-full-bordered" @input="onPassInput" placeholder="Enter Password" v-model="form.password" name="new_password" v-validate="{min:8,regex:/^(?=.{8,})(?=.*[0-9])(?=.*[A-Z])(?=.*[@#$%^&+=()!*]).*$/}">
                                                        <span @click="showNewPassword = !showNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                            <img v-if="!showNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                            <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                        </span>
                                                        <password-meter :pwd="form.password" id="password" style="display:none"></password-meter>
                                                        <span class="ml-2 mt-2" style="margin-right: -20px;">
                                                            <el-tooltip effect="light" placement="left">
                                                                <div slot="content" style="color :#000000; W1font-size: 12px;">
                                                                    <span style="font-weight: 600;">Password must contain the following</span>
                                                                    <br>
                                                                    <span >
                                                                        <span class="text-black">
                                                                            <i v-if="is_uppercase_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                            At-least one uppercase letter (ex: A to Z)
                                                                        </span><br>
                                                                        <span class="text-black">
                                                                            <i v-if="is_number_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                            At-least one digit (ex: 0 to 9)
                                                                        </span><br>
                                                                        <span class="text-black">
                                                                            <i v-if="is_special_character_pwd" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                            At-least one special character (ex: $,#,@,!,%,^,&,*,(,),)<br>
                                                                        </span>
                                                                        <span class="text-black">
                                                                            <i v-if="min_pwd_length" class="icon icon-check-circle text-success fs-14 mr-1"></i>
                                                                            <i v-else class="icon icon-close-circle text-danger fs-14 mr-1"></i>
                                                                            Minimum 8 characters
                                                                        </span><br>
                                                                    </span>
                                                                </div>
                                                                <i class="icon-information text-default-blue fs-18"></i>
                                                            </el-tooltip>
                                                        </span>
                                                    </div>
                                                    <span class="invalid-feedback-form text-danger mb-5 position-absolute" style="margin-top: 4px !important;" v-show="errors.has('new_password')">Please Enter New Password</span>
                                                </div>
                                            </div>
                                            <div class="row mt-7">
                                                <div class="col-lg-12 col-md-12 col-sm-12">
                                                    <span class="text-default-heading text-white fw-600 mt-5">Confirm New Password<span class="star ml-1">*</span></span>
                                                    <div class="d-flex aligm-items-center mt-5 position-relative">
                                                        <input v-if="!showConfirmNewPassword"   type="password" name="confirmpassword" class="digi-form-full-bordered" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                        <input v-else type="text"   class="digi-form-full-bordered" name="confirmpassword" placeholder="Enter Password" v-model="confirmPassword" v-validate="'required'">
                                                        <span @click="showConfirmNewPassword = !showConfirmNewPassword" style="width: 18px;position: absolute;right: 35px;bottom: 9px">
                                                            <img v-if="!showConfirmNewPassword" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/hide-password.svg" alt="eye" style="width: 18px;">
                                                            <img v-else src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/show-password.svg" alt="eye" style="width: 18px;">
                                                        </span>
                                                    </div>
                                                    <p v-if="errorMessage" class="text-danger">{{errorMessage}}</p>
                                                </div>
                                            </div>
                                            <div class="mt-10 forgot-password-button" style="text-align: center;">
                                                <button class="btn newcancel text-capitalize mr-5" @click="forgotPasswordCancel">Cancel</button>
                                                <button class="btn newsign-in text-capitalize"  @click="resetPassword" :disabled="ajax_progress" >Confirm 
                                                    <div class="digi-table-loader digi-button-loader-pos" v-if = "ajax_progress" >
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                        <div></div>
                                                    </div>
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                    <div v-if="activediv == 'reset successfull'" class="middle px-10 w-100" style="height:100%;">
                                        <div class="middle-left"></div>
                                        <div class="flex-column text-center">
                                            <img class="mb-12" style="height: 12em;" src="https://cdn.digicollect.com/cdn/dc_crm_fe/static/images/images/parrot.svg" alt="parrot">
                                            <p class="text-default-heading text-center mb-5 text-white" style="font-size: 30px; font-weight: 700;">Success</p>
                                            <p v-if="is_using_mobile" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your phone number at <span class="text-white fw-600">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.slice(-4)}}</span></p>
                                            <p v-if="is_using_email" class="text-default-heading text-center mb-7 text-white" style="font-size: 16px;">Your password has been successfully changed. A confirmation has been sent to your email address at <span class="text-white fw-600">{{form.login_id.slice(0,2)}}XXXXXX{{form.login_id.split("@")[0].slice(-2)}}@{{form.login_id.split("@")[1]}}</span></p>
                                            <span class="text-center">
                                                <button class="btn newsign-in text-capitalize" style="min-width: 110px; width: 160px !important;" :disabled="resend_btn_disable" @click="resetSuccessfull">OK</button>
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div style="position: absolute;bottom: 15px;left: 0px;right: 0px;">
                        <div class="mt-5" style="color: #fff;text-align: center;">
                            <span class="fs-14 fw-600 disable-select">© Copyright 2014 - {{ new Date().getFullYear() }} DigiCollect - All Rights Reserved.</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HollowDotsSpinner } from "epic-spinners";
// import auth from '../mixins/auth';
import auth from '@/components/mixins/auth';
import global from '@/components/global';
import PasswordMeter from "@/components/PasswordMeter.vue";
export default {
    // props:['product_name'], 
    data() {
        return {
            product_name: "DigiHelp",
            bgCover: "background: url('/static/images/newlogin.svg') left center no-repeat;",
            loginPage: "crm",
            account_type: "Personal",
            min_pwd_length: false,
            is_uppercase_pwd: false,
            is_number_pwd: false,
            is_special_character_pwd: false,
            enter_pass_screen: false,
            sign_in_using_otp: false,
            otp_signin_btn: false,
            show_countdown: false,
            enter_email_screen: true,
            two_factor_authentication: false,
            is_two_factor_authentication: true,
            two_factor_auth_pass_screen_active: true,
            user_not_verified: false,
            is_email_phone_valid: false,
            is_email_phone_valid_text: '',
            password_error_text: '',
            login_type: '',
            login_btn_disable: false,
            resend_verification_link_success: '',
            code_resending: false,
            resend_code_success_text: '',
            otp_error_text: '',
            two_step_signed_in_otp: false,
            forget_pass_btn_disable: false,
            forgot_pass_otp_success: false,
            is_using_email: false,
            is_using_mobile: false,
            resend_btn_disable: false,
            is_email_phone_valid_text_forget_pass: '',
            ajax_progress: false,
            show_minutes: false,
            minutes_timeout_id: undefined,
            minutes: 899,
            countdownseconds: 60,
            password_button: false,
            login_id_true: false,
            oldlogin_id: true,
            btn_loader_disable: true,
            two_step_varification_boolean: false,
        }
    },
    mixins: [auth],
    components: {
        HollowDotsSpinner,
        PasswordMeter
    },
    mounted(){
    },
    created() {
        if (this.$cookie.get("Token") && this.$route.path == '/login') {
            this.$router.push("/");
        }
        const dict = {
            custom: {
                new_password: {
                    min: () => "Minimum 8 characters",
                    regex: () => "Invalid format",
                },
            }
        };
        this.$validator.localize("en", dict);
    },
    methods: {
        checkUserIdEmpty(){
            this.login_id_true = false
            this.oldlogin_id = true
            this.form.login_id = ""
        },
        checkUserIdback(){
            this.login_id_true = false
            this.oldlogin_id = true
            this.is_email_phone_valid_text_forget_pass = ''

        },
        async loginCheckmail() {
            try{
                if (this.form.login_id.match(/[A-Za-z]/g)) {
                    this.login_type = 'email';
                    let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                    if (!check) {
                        this.is_email_valid = true;
                        this.is_email_valid_text = "Please Enter a Valid Email Address";
                        this.is_email_phone_valid_text_forget_pass = ''
                    } else {
                        this.is_email_valid = false;
                        this.is_email_valid_text = "";
                        let params = {
                            login_id: this.form.login_id
                        }
                        await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                            if(response.data.status_id == 1) {
                                this.login_id_true = true
                                this.oldlogin_id = false
                                this.form.login_id == '';
                                this.ajax_progress = false
                            }
                        }).catch((err)=>{
                            this.ajax_progress = false
                            if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                                this.enter_email_screen = false;
                                this.user_not_verified = true;
                            }else {
                                this.is_email_phone_valid = true;
                            }
                        });
                    }
                } 
            } catch(err){
                this.ajax_progress = false
                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                    this.enter_email_screen = false;
                    this.user_not_verified = true;
                }else {
                    this.is_email_phone_valid = true;
                }
            }
        },
        countDownMinutes() {
            this.show_minutes = true
            if(this.countdownseconds == 0){
                this.countdownseconds = 60;
            }
            if (this.minutes > 0) {
                this.minutes_timeout_id = setTimeout(() => {
                    this.minutes -= 1;
                    this.countdownseconds -=1;
                    this.countDownMinutes();
                }, 1000);
            } else if (this.minutes === 0) {
                this.show_minutes = false
                this.countdownseconds = 0;
                this.is_using_email = false
                this.is_using_mobile = false
            }
        },
        forgotPasswordCancel(){
            if(this.form.login_id == ''){
                this.activediv = 'login';
                this.login_id_true = false
                this.oldlogin_id = true
                this.enter_email_screen = true;
                this.two_factor_authentication= false,
                this.is_email_phone_valid_text_forget_pass = ''

            }else {
                this.activediv = 'login';
                this.enter_email_screen = false;
                this.login_btn_disable = false;
                this.forget_pass_btn_disable = false;
                this.is_two_factor_authentication = true;
                this.two_factor_auth_pass_screen_active = true;
                this.forgot_pass_otp_success = false;
                this.is_email_phone_valid_text_forget_pass = ''
                this.confirmPassword= '';
                if(this.two_step_varification_boolean) {
                    this.two_factor_authentication = true;
                    this.enter_pass_screen = false;
                } else {
                    this.two_factor_authentication = false;
                    this.enter_pass_screen = true;
                }
            }
            
        },
        cancelPassScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;
        },
        cancelOtpScreen() {
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.sign_in_using_otp = false;
            this.login_btn_disable = false;
            this.two_factor_authentication = false;
        },
        cancelTwoFactor() {
            this.two_factor_authentication = false;
            this.enter_email_screen = true;
            this.enter_pass_screen = false;
            this.login_btn_disable = false;

        },
        checkUserId() {
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,50})+$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            } else {
                this.login_type = 'phone';
                let check = this.form.login_id.match(/^\d{10}$/);
                if (!check) {
                    this.is_email_valid = true;
                    this.is_email_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";
                }
            }
        },
        goToNext(type) {
            this.ajax_progress = true
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                this.login_type = 'email';
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    console.log("helloooooooo")
                    this.is_email_valid = true;
                    this.is_email_phone_valid = true;
                     this.is_email_phone_valid_text = "Please Enter a Valid Email Address";
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_valid = false;
                    this.is_email_valid_text = "";  
                }
            }
            if (this.form.login_id.match(/[A-Za-z]/g)) {
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    console.log("hello12345")
                    this.is_email_phone_valid = true;
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                    this.is_email_phone_valid_text_forget_pass = ''
                } else {
                    this.is_email_phone_valid = false;
                    if(type == 'login') {
                    console.log("hello12sjhdfjsdh345")
                        // this.$refs.password.focus();
                        // this.$nextTick(() => {
                        //     this.$refs.password.focus();
                        // });
                        this.two_factor_auth_pass_screen_active = true
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                    console.log("hello123jsfhsjdhsdsdjsk45")
                        this.is_using_email = true;
                        this.is_using_mobile = false;
                        this.getOtpForgetPass('send');
                    }
                }
            } else {
                let check = this.form.login_id.match(/^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{3,50})+$/);
                if (!check) {
                    console.log("validatio1")
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = "Please Enter a Email Address";
                    if(this.form.login_id == ''){
                        this.is_email_valid_text = false
                    }
                    this.is_email_phone_valid_text_forget_pass = 'Please Enter a Email Address'
                } else {
                    this.is_email_phone_valid = false;
                    if(type == 'login') {
                    console.log("validatio12")
                        // this.$refs.password.focus();
                        this.$nextTick(() => {
                            this.$refs.password.focus();
                        });
                        this.two_factor_auth_pass_screen_active = true
                        this.loginCheck();
                        this.form.password = '';
                    }
                    else {
                    console.log("validatio13")
                        this.is_using_email = true;
                        this.is_using_mobile = false;
                        this.getOtpForgetPass('send');
                    }
                }
            }
            this.ajax_progress = false
        },
        async loginCheck() {
            try{
                this.login_btn_disable = true;
                this.ajax_progress = true
                let params = {
                    login_id: this.form.login_id
                }
                await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                    if(response.data.status_id == 1) {
                        
                        // this.form.login_id == '';
                        this.login_id_true = true;
                        this.oldlogin_id = false;
                        if(response.data.is_two_step_verification == true) {
                            this.two_step_varification_boolean = response.data.is_two_step_verification
                            this.two_factor_authentication = true;
                            this.enter_email_screen = false;
                            this.sign_in_using_otp = false;
                        }
                        else {
                            this.enter_pass_screen = true;
                            this.enter_email_screen = false;
                        
                        }
                        this.ajax_progress = false
                    }
                }).catch((err)=>{
                    this.login_btn_disable = false;
                    this.ajax_progress = false
                    if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                        this.enter_email_screen = false;
                        this.user_not_verified = true;
                    }else {
                        this.is_email_phone_valid = true;
                        this.is_email_phone_valid_text = err.response.data.reason;
                    }
                });
            } catch(err){
                this.login_btn_disable = false;
                this.ajax_progress = false
                if(err.response.data.reason == 'Login Id Not Verified. Please Verify') {
                    this.enter_email_screen = false;
                    this.user_not_verified = true;
                }else {
                    this.is_email_phone_valid = true;
                    this.is_email_phone_valid_text = err.response.data.reason;
                }
            }
        },
        cancelResendLink() {
            window.location.href = global.HELP_URL;
        },
        async resendUserVerifyLink() {
            try{
                this.resend_btn_disable = true;
                let params = {
                    login_id: this.form.login_id,
                }
                await this.$http.post(global.ADMIN_API + "/registration/resend/link", params).then((response) => {
                    let res = response.data
                    if(res.status_id == 1) {
                        this.resend_verification_link_success = res.response;
                        setTimeout(() => {
                            this.resend_verification_link_success = '';
                            window.location.href = global.HELP_URL;
                        }, 2000);
                    }
                }).catch((err)=>{
                    this.resend_verification_link_success = err.response.data.reason;
                    this.resend_btn_disable = false;
                });
            } catch(err){
                this.resend_verification_link_success = err.response.data.reason;
                this.resend_btn_disable = false;
            }
        },
        async loginUsingPassword(type) {
            try{
                if(this.form.password.length == 0) {
                    this.password_error_text = 'Please Enter a Password';
                }
                else {
                    this.signedIn = true;
                    let params = {
                        login_id: this.form.login_id,
                        password: this.form.password
                    }
                    await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                        this.ajax_progress = true
                        if(response.data.status_id == 1) {
                            if(type == 'one-step') {
                                if(response.data.token) {
                                    this.$cookie.set("Token", response.data.token, {
                                        expires: 7,
                                        domain: "digicollect.com",
                                    });
                                    this.$cookie.set("session_id", response.data.session_id, {
                                        expires: 7,
                                        domain: "digicollect.com",
                                    });
                                    if (this.$route.query.redirect_to) {
                                        window.location.href = this.$route.query.redirect_to;
                                    } else {
                                        this.$store.commit("setToken", response.data.token);
                                        window.location.href = global.HELP_URL;
                                    }
                                }
                                this.ajax_progress = false
                            }
                            else if(type == 'two-step') {
                                if(response.data.message == 'Please Enter Otp For Verification.' || response.data.is_two_step_verification == true) {
                                    this.two_factor_auth_pass_screen_active = false;
                                    this.enter_pass_screen= false;
                                    // sign_in_using_otp
                                    this.countDownTimer();
                                    this.signedIn = false;                                }
                                this.ajax_progress = false
                            }
                        }
                    }).catch((err)=>{
                        this.password_error_text = err.response.data.reason;
                        this.ajax_progress = false
                        this.signedIn = false;
                        if(type == 'two-step'){
                            this.enter_pass_screen= false;
                            this.two_factor_authentication = true;
                            this.form.password = "";
                        }
                        else {
                            this.two_factor_authentication = false;
                            this.enter_pass_screen= true;
                            this.form.password = "";
                        }
                    });
                }
                // this.form.password='';
            } catch(err){
                console.log("err")
                this.password_error_text = err.response.data.reason;
                this.ajax_progress = false
                this.signedIn = false;
                this.form.password = "";
                this.two_factor_authentication = true
                if(type == 'two-step'){
                            this.enter_pass_screen= false;
                        }
                
            }
        },
        async loginUsingOtp(type) {
            try{
                if(type == 'one-step') {
                    this.signedIn = true;
                }
                else {
                    this.two_step_signed_in_otp = true;
                }
                let params = {
                    login_id: this.form.login_id,
                    otp: this.otpValue
                }
                await this.$http.post(global.ADMIN_API + "/auth/", params).then((response)=>{
                    if(response.data.status_id == 1 && response.data.token) {
                        this.ajax_progress = true
                        this.$cookie.set("Token", response.data.token, {
                            expires: 7,
                            domain: "digicollect.com",
                        });
                        this.$cookie.set("session_id", response.data.session_id, {
                            expires: 7,
                            domain: "digicollect.com",
                        });
                        if (this.$route.query.redirect_to) {
                            window.location.href = this.$route.query.redirect_to;
                        } else {
                            this.$store.commit("setToken", response.data.token);
                            window.location.href = global.HELP_URL;
                        }
                        this.ajax_progress = false
                    }
                }).catch((err)=>{
                    this.otpInvalid = true;
                    this.ajax_progress = false
                    this.otp_error_text = err.response.data.reason;
                    if(type == 'one-step') {
                        this.signedIn = false;
                        this.handleClearInput();
                    }
                    else {
                        this.two_step_signed_in_otp = false;
                        this.handleClearInput();
                    }
                    this.otpValue = "";
                })
            } catch(err) {
                this.otpInvalid = true;
                this.ajax_progress = false
                this.otp_error_text = err.response.data.reason;
                if(type == 'one-step') {
                    this.signedIn = false;
                    this.handleClearInput();
                }
                else {
                    this.two_step_signed_in_otp = false;
                    this.handleClearInput();
                }
                this.otpValue = "";
            }
        },
        handleClearInput() {
            this.$refs.otpInput.clearInput();
        },
        otpInputActive() {
            this.loginUsingPassword('two-step');
            this.password_button = false
            clearTimeout(this.minutes_timeout_id);
            this.minutes = 899;
            this.countdown = 59;
            this.countdownseconds = 60;
            this.countDownMinutes();
            // this.form.password = '';
        },
        async goToOtpLogin(type, new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            if(type == 'send') {
                this.sign_in_using_otp = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
                if(new_type && new_type =='two-factor-otp') {
                    this.password_button = true
                    this.two_factor_auth_pass_screen_active = false
                }
            }
            if(type == 'resend') {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();
                try {
                    let params = {
                        login_id: this.form.login_id,
                        otp_for: 'login'
                    }
                    await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response) => {
                        if(response.data.status_id == 1) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.message;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        } else if(response.data.status_id == 0) {
                            if(type == 'resend') {
                                this.resend_code_success_text = response.data.reason;
                                setTimeout(() => {
                                    this.resend_code_success_text = '';
                                }, 2000);
                                this.code_resending = false;
                            }
                        }
                    }).catch((err)=>{
                        if(type == 'resend') {
                            this.resend_code_success_text = err.response.data.reason;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                    });
                }
                catch(err) {
                    if(type == 'resend') {
                        this.resend_code_success_text = err.response.data.reason;
                        setTimeout(() => {
                            this.resend_code_success_text = '';
                        }, 2000);
                        this.code_resending = false;
                    }
                }


        },
        goToPassLogin(new_type) {
            this.otpInvalid = false;
            this.otp_error_text = '';
            this.password_error_text = '';
            this.sign_in_using_otp = false;
            if(new_type && new_type =='two-factor-password') {
                this.two_factor_auth_pass_screen_active = true
            }
        },
        onPassInput(e) {
            if(e.target.value.match(/^(?=.{8,}$)/)) {
                this.min_pwd_length = true;
            }
            else {
                this.min_pwd_length = false;
            }
            if(e.target.value.match(/^(?=.*[A-Z])/)) {
                this.is_uppercase_pwd = true;
            } else {
                this.is_uppercase_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[0-9])/)) {
                this.is_number_pwd = true;
            } else {
                this.is_number_pwd = false;
            }
            if(e.target.value.match(/^(?=.*[!@#$%^&*()])/)) {
                this.is_special_character_pwd = true;
            } else {
                this.is_special_character_pwd = false;
            }
        },

        async getOtpForgetPass(type) {
            if(type == 'send') {
                this.forget_pass_btn_disable = true;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            else {
                this.code_resending = true;
                this.otpInvalid = false;
                clearTimeout(this.minutes_timeout_id);
                this.minutes = 899;
                this.countdown = 60;
                this.countdownseconds = 60;
                this.countDownMinutes();
            }
            this.countDownTimer();
            try{
                let params = {
                    login_id: this.form.login_id,
                    otp_for: 'reset'
                }
                await this.$http.post(global.ADMIN_API + "/auth/otp", params).then((response)=>{
                    if(response.data.status_id == 1) {
                        this.ajax_progress = true
                        if(type == 'resend') {
                            this.resend_code_success_text = response.data.message;
                            setTimeout(() => {
                                this.resend_code_success_text = '';
                            }, 2000);
                            this.code_resending = false;
                        }
                        else {
                            this.activediv = 'verify otp';
                        }
                        this.ajax_progress = false
                    }
                }).catch((err)=>{
                    this.forget_pass_btn_disable = false;
                    this.ajax_progress = false
                    if(type == 'send') {
                        this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                    } else if(type == 'resend') {
                        this.resend_code_success_text = err.response.data.reason;
                    }
                });
            } catch(err) {
                this.forget_pass_btn_disable = false;
                this.ajax_progress = false
                if(type == 'send') {
                    this.is_email_phone_valid_text_forget_pass = err.response.data.reason;
                } else if(type == 'resend') {
                    this.resend_code_success_text = err.response.data.reason;
                }
            }
        },
        async verifyOtpForgotPass() {
            try {
                this.forgot_pass_otp_success = true;
                let params = {
                    login_id: this.form.login_id,
                    otp: this.otpValue,
                    otp_for: 'reset'
                }
                await this.$http.post(global.ADMIN_API + "/auth/otp/verify", params).then((response)=>{
                    this.ajax_progress = true
                    if(response.data.status_id == 1 ) {
                        this.activediv = 'set new password';
                    }
                    this.ajax_progress = false
                }).catch((err)=>{
                    this.otp_error_text = err.response.data.reason;
                    this.ajax_progress = false
                    this.otpInvalid = true;
                    this.otpValue = "";
                    this.forgot_pass_otp_success = false;
                })
            } catch(err){
                this.otp_error_text = err.response.data.reason;
                this.ajax_progress = false
                this.otpInvalid = true;
                this.otpValue = "";
                this.forgot_pass_otp_success = false;
            }
        },
        async resetPasswordConfirm() {
            try {
                this.ajax_progress = true
                let params = {
                    login_id: this.form.login_id,
                    password: this.form.password
                }
                await this.$http.post(global.ADMIN_API + "/auth/reset", params).then((response) => {
                    if(response.data.status_id == 1) {
                        this.activediv = "reset successfull";
                    }
                    this.ajax_progress = false
                }).catch((err) => {
                    this.ajax_progress = false
                    this.errorMessage = err.response.data.reason;
                })
            } catch(err){
                this.ajax_progress = false
                this.errorMessage = err.response.data.reason;
            }
        },
        async resetPassword() {
            this.$validator.validateAll().then(async result => {
                if (result && this.form.password && this.confirmPassword === this.form.password && !this.errorMessage) {
                    this.resetPasswordConfirm();
                } else if (!this.form.password || !this.confirmPassword) {
                    this.errorMessage = "Please fill both fields";
                } else if(this.confirmPassword !== this.form.password) {
                    this.errorMessage = "Confirm Password not Matched";
                }
            })
        }
    },
    watch: {
        "$route.path": function (path) {
            if (this.$cookie.get("Token") && path == '/login') {
                this.$router.push("/");
            }
        },
    }
}
</script>

<style scoped>
    .font-size-header{
        font-size: 30px;
    }
    .width-leftbox{
        width:100%;
    }
    .text-default-blue {
        color: white !important;
        font-weight: 600;
    }

    .disable-select{
        -webkit-user-select: none;
    }
    .digi-button-loader-pos{
        position: absolute;
        top: -11px;
        left: 37px;
    }     
    .highlighted-white {
        color: #ffffff !important;
        padding-bottom: 5px;
        text-decoration: underline;
        text-decoration-thickness: 0.7px !important;
    }
    .full-width-text {
        display: block;  
        width: 100%;     
        word-wrap: break-word;
        /* word-break: break-all; */
        white-space: pre-wrap;
        text-align: justify !important; 
    }

    .forgot-password{
        font-size: 35px;
    }
    .image-holder {
        width: 500px;
        background: #fff;
        height: 500px;
        border-radius: 50%;
        bottom: -90px;
        position: absolute;
        left: -60px;
    }
    .group-image {
        width: 350px;
        height: 350px;
        right: 60px;
        position: absolute;
        top: 60px;
    }
    .top {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        padding-top: 10px;
        padding-bottom: 0px;
        padding-left: 80px;
        padding-right: 80px;
    }
    .middle-left {
        width: 50%;
    }
    .middle-right {
        width: 50%;
    }
    .star {
        font-size: 12px;
        color: #F44336;
    }
    .bg-image{
        /* background-image: url("/static/images/login_bg1.png")left center no-repeat; */
    }
    .fs-24{
        font-size: 24px;
    }
    hr.streamLine {
        margin-top: 0.4rem;
        margin-bottom: 0.4rem;
        border: 0;
        border-top: 5px solid #fff;
        width: 65px !important;
        color: #fff !important;
        text-align: left !important;
        left: 0 !important;
        margin-left: 0!important;
    }

    @media (min-width: 400px) {
        .right-box {
            width: 40rem;
            float: none;
            min-height: 50rem;
        }
    }

    @media (min-width: 600px) {
        .right-box {
            width: 40rem;
            float: right;
            min-height: 50rem;
        }
        .h-30-20-10rem {
            height: 20rem;
        }
        .h-30-18-10rem {
            height: 20rem;
        }
        .otp-input, .otp-input-warning {
            width: 36px !important;
            height: 36px !important;
            margin-right: 21px !important;
        }
    }

    @media (min-width: 960px) {
        .right-box {
            width: 45rem;
            min-height: 42rem;
        }
        .h-30-20-10rem {
            height: 22rem;
        }
        .h-30-18-10rem {
            height: 13rem;
        }
    }
    @media (min-width: 1280px) {
        .right-box {
            width: 50rem;
            min-height: 48rem;
        }
        .h-30-20-10rem {
            height: 26rem;
        }
        .h-30-18-10rem {
            height: 20rem;
        }
    }
    @media (min-width: 1400px) {
        .right-box {
            width: 60rem;
            min-height: 52rem;
        }
        .h-30-20-10rem {
            height: 30rem;
        }
        .h-30-18-10rem {
            height: 20rem;
        }
    }
    .right-box {
        height: 100%;
        margin: 0 0 0.5px 50.5px;
        padding-left: 40px;
        padding-right: 40px;
        padding-top: 20px;
        padding-bottom: 20px;
        object-fit: contain;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff1f;
    }
    .text-center{
        text-align: center !important;
    }
    .sign-in{
        width: 130px;
        height: 40px;
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
    }
    .cancel{
        width: 130px;
        height: 40px;
        padding: 2.5px 22px 4.5px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        color: #fff;
        font-weight: 800;
        border: 1px solid #94bbe3;
        background-color: #4789cd;
    }
    .newsign-in:disabled{
        width: 130px !important;
        height: 40px !important;
        padding: 1px 22px 4.5px 22px !important;
        object-fit: contain !important;
        border-radius: 6.5px !important;
        border: 1px solid #4789cd !important;
        color: #4789cd !important;
        font-weight: 800 !important;
        border-radius: 13.5px !important;
        -webkit-backdrop-filter: blur(20.7px) !important;
        backdrop-filter: blur(41px) !important;
        font-size: 16px !important;
        background-color: #ffffff00 !important;
    }
    @media (max-width: 1270px) {
        hr{
            display: none !important;
        }
    }
    .newcancel{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 4px 22px 4px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #fff;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff00;
        font-size: 16px !important;
    }
    .newcancel:hover{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 4px 22px 4px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #f4f4f4;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
        font-size: 16px !important;
    }
    .newsign-in{
        width: 130px;
        height: 40px;
        /* margin: 18.5px 0 12.5px 0.5px; */
        padding: 4px 22px 4px 22px;
        object-fit: contain;
        border-radius: 6.5px;
        border: 1px solid #4789cd;
        color: #fff;
        font-weight: 800;
        border-radius: 13.5px;
        background-image: linear-gradient(to bottom, #94bbe3, #4789cd);
        font-size: 16px !important;
    }
    .resend-code{
        width: 120px;
        height: 34px;
        padding: 0 0px 0 0px;
        object-fit: contain;
        border-radius: 2px !important;
        color: #00448b !important;
        font-weight: 800;
        border-radius: 13.5px;
        -webkit-backdrop-filter: blur(20.7px);
        backdrop-filter: blur(41px);
        background-color: #ffffff4f !important;
    }
    @media only screen and (min-width: 0px) and (max-width: 768px){
        .newflex-reverse {
            display: flex;
            align-items: flex-start !important;
            position: relative;
            flex-direction: column-reverse !important;
        }
        .top{
            display: flex;
            flex-direction: row;
            justify-content: space-between;
            align-items: center;
            padding-top: 10px;
            padding-bottom: 0px;
            padding-left: 10px;
            padding-right: 10px;
        }
        .right-box{
            margin: 0 auto;
        }
    }
    .bor-der::before {
        content: "";
        position: absolute;
        top: 100%;
        width: 100%;
        left: 0;
        height: 3px;
        border-radius: 2px;
        background: #fff;
    }
    .resend-code.resend-active {
        background-image: linear-gradient(to bottom, #91b9e2, #4d8cce);
        color: #fff;
    } 

    /* login css */
    .main-bg {
        height: 100%;
        background-color: #fff;
    }
    @media (max-width: 1200px) {
        .inner-bg {
            background: #fff !important;
        }
        .main-bg {
            background: #fff !important;
        }
        .register-bg {
            background: #fff !important;
        }
        .dc {
            color: #00448b;
        }
        .copyright {
            color: #00448b !important;
        }
    }
    @media (max-height: 690px) {
        .inner-bg {
            background: #fff !important;
        }
        .main-bg {
            background: #fff !important;
        }
        .register-bg {
            background: #fff !important;
        }
        .dc {
            color: #00448b;
        }
        .copyright {
            color: #00448b !important;
        }
    }
    .hidden
    {
        display: none !important;
    }
    .min-w-0
    {
        min-width: 0px !important;
    }
    .flex
    {
        display: flex !important;
    }
    .relative
    {
        position: relative !important;
    }
    .w-1\/2
    {
        width: 50% !important;
    }
    .h-full
    {
        height: 100% !important;
    }
    .w-full
    {
        width: 100% !important;
    }
    .flex-auto
    {
        flex: 1 1 auto !important;
    }
    .flex-col
    {
        flex-direction: column !important;
    }
    .login-outlet {
        position: relative;
        display: flex;
        flex: 1 1 auto;
        width: 100%;
    }
    .items-center
    {
        align-items: center !important;
    }
    .dark\:border-r
    {
        border-right-width: 1px !important;
    }
    .overflow-hidden
    {
        overflow: hidden !important;
    }
    .justify-center
    {
        justify-content: center !important;
    }
    .justify-start
    {
        justify-content: start !important;
    }
    .justify-end
    {
        justify-content: end !important;
    }
    .justify-between
    {
        justify-content: space-between !important;
    }
    .flex-0
    {
        flex: 0 0 auto !important;
    }
    .flex-wrap
    {
        flex-wrap: wrap !important;
    }
    .p-16rem {
        padding: 4rem !important;
    }
    .otp-input {
        border: 1px solid rgba(0, 0, 0, 0.41) !important;
        width: 35px !important;
        height: 35px !important;
        border-radius: 5px !important;
        text-align: center !important;
        margin-right: 15px !important;
    }
    .otp-input-warning {
        border: 1px solid #ff3b3b !important;
        width: 35px !important;
        height: 35px !important;
        border-radius: 5px !important;
        text-align: center !important;
        margin-right: 15px !important;
    }
    @media (min-width: 600px) {
        .sm\:p-12{
            padding: 3rem !important;
        }
    .sm\:rounded-2xl
    {
        border-radius: 1rem !important;
    }
    .sm\:w-auto
    {
        width: auto !important;
    }
    .sm\:justify-center
    {
        justify-content: center !important;
    }
    .sm\:flex-row
    {
        flex-direction: row !important;
    }
            .otp-input, .otp-input-warning {
                width: 36px !important;
                height: 36px !important;
                margin-right: 21px !important;
            }
    }
    @media (min-width: 960px) {
        .md\:w-1\/2
        {
            width: 50% !important;
        }
        .md\:h-full
        {
            height: 100% !important;
        }
            .md\:flex
        {
            display: flex !important;
        }
            .md\:items-start
        {
            align-items: flex-start !important;
        }
        .md\:justify-start
        {
            justify-content: flex-start !important;
        }
        .md\:p-16
        {
            padding: 4rem !important;
        }
        .md\:p-16login
        {
            padding-left: 8rem !important;
            padding-right: 8rem !important;
            padding-top: 0rem !important;
            padding-bottom: 1rem !important;
        }
        .md\:rounded-none
        {
            border-radius: 0 !important;
        }
        .md\:justify-end
        {
            justify-content: flex-end !important;
        }
        .md\:items-center
        {
            align-items: center !important;
        }
        .otp-input, .otp-input-warning {
            width: 40px !important;
            height: 40px !important;
            margin-right: 26px !important;
        }
        .padding-x{
            padding-left: 7.9rem !important;
            padding-right: 5.4rem !important;
        }
        .width-leftbox{
            width:88% !important;
        }
    }
    @media (min-width: 1280px) {
        .lg\:px-28 {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
        }
        .lg\:pxy-28login {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
            padding-top: 0rem !important;
            padding-bottom: 1rem !important;
        }
        .pxy-28loginheader {
            padding-left: 7rem !important;
            padding-right: 7rem !important;
            padding-top: 4rem !important;
            padding-bottom: 2rem !important;
        }
        .otp-input, .otp-input-warning {
            width: 50px !important;
            height: 50px !important;
            margin-right: 24px !important;
        }
        .padding-x{
            padding-left: 6.9rem !important;
            padding-right: 4.4rem !important;

        }
        .width-leftbox[data-v-52c8a31a] {
            width: 88% !important;
        }
        .padding-bottom{
            padding-bottom: 1.0rem !important;
        }


    }
    @media (min-width: 1400px) {
        .lg\:pxy-28login {
            padding-left: 10rem !important;
            padding-right: 10rem !important;
            padding-top: 0rem !important;
            padding-bottom: 3rem !important;
        }
        .pxy-28loginheader {
            padding-left: 10rem !important;
            padding-right: 10rem !important;
            padding-top: 4rem !important;
            padding-bottom: 2rem !important;
        }
        .otp-input, .otp-input-warning {
            width: 60px !important;
            height: 60px !important;
            margin-right: 32px !important;
        }
        .padding-x{
            padding-left: 9.4rem !important;
            padding-right: 7.4rem !important;
        }
        .width-leftbox[data-v-52c8a31a] {
            width: 100% !important;
        }
        .padding-bottom{
            padding-bottom: 2.0rem !important;
        }
    }
    @media (min-width: 1600px) {
        
        .width-leftbox[data-v-52c8a31a] {
            width: 100% !important;
        }
        .right-box {
            width: 58rem;
            min-height: 57rem;
        }
    }
    .cr-backimg {
        width: 100%;
        height: 100%;
        overflow-y: auto;
        background-image: url('/static/images/new-theme2024/login_bg1.png') !important;
        background-size: cover !important;
    }
    .dc-new {
        display: inline-block;
    }
    input.digi-form-full-bordered {
        font-size: 14px;
        padding: 8px 10px 8px 10px;
        display: block;
        width: 100%;
        border: none;
        border: 1px solid #cecfd0;
        border-radius: 5px !important;
    }
    input.digi-form-full-bordered::placeholder {
        color: #cecfd0;
    }
    @media (min-width: 1700px) {
        .padding-bottom{
            padding-bottom: 5.4rem !important;
        }
    }

</style>